import React from "react";
import {Button, Checkbox, FormControlLabel, Typography} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import FixablyModal from "./FixablyModal";
import InitialsPad from "./InitialsPad";

// Only for an older Core that sends no labels.
const DEFAULT_LABELS = {
    title: 'Additional terms',
    description: 'Tick and initial each term to continue.',
    agree: 'I agree to this term',
    initials: 'Initials',
    clear: 'Clear',
    continue: 'Continue',
};

export function isTermComplete(entry) {
    return !!(entry && entry.agreed && entry.dataUrl);
}

export function areAllTermsComplete(terms, entries) {
    return terms.length > 0 && terms.every((_, index) => isTermComplete(entries[index]));
}

export default function AdditionalTermsDialog(props) {
    const {open, terms, labels, entries, onChange, onClose, onContinue} = props;

    const text = {...DEFAULT_LABELS, ...(labels || {})};
    const entryAt = (index) => entries[index] || {agreed: false, points: null, dataUrl: null};

    return (
        <FixablyModal fullScreen title={text.title} open={open} onClose={onClose}>
            <div style={{flex: 1, width: '100%', overflowY: 'auto', padding: '0 24px', boxSizing: 'border-box'}}>
                {text.description && <Typography style={{marginBottom: 12}}>{text.description}</Typography>}
                {terms.map((term, index) => {
                    const entry = entryAt(index);
                    return (
                        <section key={index} data-testid='additional-term' style={{padding: '12px 0', borderTop: 'solid 1px rgba(0, 0, 0, 0.12)'}}>
                            <Typography style={{whiteSpace: 'pre-line'}}>{term.text}</Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={entry.agreed}
                                        onChange={(e) => onChange(index, {...entry, agreed: e.target.checked})}
                                        color="primary"
                                    />
                                }
                                label={text.agree}
                            />
                            <Typography variant='caption' component='div' style={{marginBottom: 4}}>
                                {text.initials}
                            </Typography>
                            <InitialsPad
                                points={entry.points}
                                clearLabel={text.clear}
                                onChange={(drawing) => onChange(index, {
                                    ...entry,
                                    points: drawing ? drawing.points : null,
                                    dataUrl: drawing ? drawing.dataUrl : null,
                                })}
                            />
                        </section>
                    );
                })}
            </div>
            <div style={{padding: 12}}>
                <Button
                    variant='contained'
                    color='secondary'
                    disabled={!areAllTermsComplete(terms, entries)}
                    onClick={onContinue}
                    endIcon={<ArrowForwardIcon/>}>
                    {text.continue}
                </Button>
            </div>
        </FixablyModal>
    );
}
